export const getTimeText = time => {
	if (!isNaN(time)) {
		if (time > 1e9 && time < 1e12) {
			time *= 1000;
		}
		time = new Date(time);
	}

	const now = new Date();

	if (now.getFullYear() === time.getFullYear() && now.getMonth() === time.getMonth() && now.getDate() === time.getDate()) {
		return time.toLocaleTimeString(undefined, { hour12: true, hour: '2-digit', minute: '2-digit' });
	} else if (now.getFullYear() === time.getFullYear()) {
		return time.toLocaleString(undefined, { hour12: true, hour: '2-digit', minute: '2-digit', month: 'short', day: 'numeric' });
	} else {
		return time.toLocaleString(undefined, { hour12: true, hour: '2-digit', minute: '2-digit', year: 'numeric', month: 'short', day: 'numeric' });
	}
}

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const testMatch = (reaction, text) => {
	if (reaction.match_type === 'match' && text === reaction.val) {
		return true;
	} else if (reaction.match_type === 'range') {
		const [min, max] = reaction.val.split(',');
		return parseFloat(text) >= +min && parseFloat(text) <= +max;
	} else if (reaction.match_type === 'ge') {
		return parseFloat(text) >= +reaction.val;
	} else if (reaction.match_type === 'eq') {
		return parseFloat(text) == +reaction.val;
	} else if (reaction.match_type === 'le') {
		return parseFloat(text) <= +reaction.val;
	} else if (reaction.match_type === 'gt') {
		return parseFloat(text) > +reaction.val;
	} else if (reaction.match_type === 'lt') {
		return parseFloat(text) < +reaction.val;
	} else if (reaction.match_type === 'regexp' && new RegExp(reaction.regex)[Symbol.match](text)) {
		return true;
	} else if (reaction.match_type === 'pattern') {
		return matchPattern(reaction.validate, text);
	} else if (reaction.match_type === 'global_error') {
		return true;
	} else {
		return false;
	}
}

export const matchPattern = (pattern, text) => {
	if (!pattern) return true;
	// let val;
	let parts, val, val2, min, max;
	if (pattern.indexOf(":") >= 0) {
		parts = pattern.split(":");
		pattern = parts[0];
		val = parts[1];
		if (parts[2])
			val2 = parts[2];
	}
	switch (pattern) {
		// case "is-same":
		// 	let e1 = $('input[name="' + val + '"]'), e2 = $('input[name="' + val2 + '"]');
		// 	return e1 && e2 && e1.length > 0 && e2.length > 0 && e1[0].value === e2[0].value;
		case "kanji":
			return text.match(/^[一-龯]+$/);
		case "katakana":
			return text.match(/^[ァ-ヺ\s　ー]*$/);
		case "hirakana":
			return text.match(/^[ぁ-ん\s　]*$/);
		case "number":
			return text.match(/^[\d\.]+$/);
		case "email":
			return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(.+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(text);
		case "phone-jp":
			return /^\d{2,4}[\-ー−]*\d{3,4}[\-ー−]*\d{3,4}$/.test(text);
		case "zipcode-jp":
			return /^\d{3}[\-ー−]*\d{4}$/.test(text);
		case "url":
			return /^\//.test(text) || /^((http|https|ftp)\:\/\/)*([a-zA-Z0-9\.\-]+(\:[a-zA-Z0-9\.&%\$\-]+)*@)*((25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9])\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[1-9]|0)\.(25[0-5]|2[0-4][0-9]|[0-1]{1}[0-9]{2}|[1-9]{1}[0-9]{1}|[0-9])|([a-zA-Z0-9\-]+\.)*[a-zA-Z0-9\-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|xyz|link|[a-zA-Z]{2,6}))(\:[0-9]+)*(\/($|[a-zA-Z0-9\.\,\?\'\\\+&;%\$#\=~_\-@:+!\(\)]+))*$/.test(text);
		case "len":
			min = parseInt(parts[1]);
			max = parts.length >= 3 ? parseInt(parts[2]) : Number.MAX_SAFE_INTEGER;
			return text.length >= min && text.length <= max;
		case "Ymd":
			return /[12]\d{3}[\-ー年\.−]*\d{1,2}[\-ー月\.−]*\d{1,2}/.test(text);
		case "Ym":
			return /[12]\d{3}[\-ー年\.−]*\d{1,2}/.test(text);
		case "Ymdhi":
			return /[12]\d{3}[\-ー年\.−]*\d{1,2}[\-ー月\.−]*\d{1,2}\s+(午前|午後|am|pm)*\d{1,2}[時:]\d{1,2}/.test(text);
		case "hi":
			return /^(午前|午後|am|pm)*\d{1,2}[時:]\d{1,2}/.test(text);
		case "name":
			return text.match(/^([\u00c0-\u01ffa-zA-Z'\-ァ-ヺー・ぁ-ん一-龯\u4e00-\u9a05])+([\s　]*[\u00c0-\u01ffa-zA-Z'-ァ-ヺー・ぁ-ん一-龯\u4e00-\u9a05]+)*/i);
		case "line"://line id
			return text.match(/^([.\-_0-9a-z]+)$/i);
		case "age"://
			return text.match(/^[0-9一二三四五六七八九十百零\s　]+(years\b|yrs*\b|歳|才|岁)*$/);
		case "price"://
			return text.match(/^([0-9\.一壱壹弌二弐貳貮贰三参參弎叁叄四肆五伍六陸陸七漆柒八捌九玖拾廿卄卅丗卌百十陌千阡仟萬億兆零\s　]+(.*(ドル|ヲン|ユーロ|€|＄|£|㌦|㍀|\$|¥|￥)|.*[円元鎊株币圓角块塊分刀毛]|yen|jpy|usd|cny|fr|eur|bgp|\bb\b|\bm\b|\bk\b|billiions*|millions*|hundreds*|thousands*)*)+$/i);
		case "az09"://
			return text.match(/^([0-9a-z]+)$/);
	}
	return true;
}

export const htmlDecode = input => {
	const doc = new DOMParser().parseFromString(input, "text/html");
	return doc.documentElement.textContent;
}

export const fullDecode = input => {
	return unescape(htmlDecode(unescape(htmlDecode(input))));
}

export default {
	getTimeText,
	sleep,
	matchPattern,
	htmlDecode,
	fullDecode
};